import 'css-chunksrc/client/pages/projectPage/documentsPage/reportsPage/reportsList/report/indicatorsList/styles.scss';export default {
  "indicatorsList": "_indicatorsList_wn9bo_1",
  "input": "_input_wn9bo_10",
  "indicator": "_indicator_wn9bo_1",
  "name": "_name_wn9bo_27"
};